import Payment from "./PaymentArea";

export default Payment;
